'use es6';

const mediaBridgeShortCircuit = `
        if (iframeWrapper.dataset.sourceType === 'media_bridge') {
          // media-bridge-embed-js is included on page will render these instead
          if (window.hsMediaBridgeApi) {
            return;
          } else {
            console.warn('Install media-bridge-embed-js for ideal media bridge embed rendering.');
          }
        }`;
export const getEmbedFieldSnippetWithCssAndJs = (fieldNamePath, withMediaBridge = false) => {
  const oEmbedCase = withMediaBridge ? `{% if ${fieldNamePath}.source_type == "oembed" || ${fieldNamePath}.source_type == "media_bridge" %}
  {% set oEmbedData = ${fieldNamePath}.source_type == "media_bridge" ? ${fieldNamePath}.media_bridge_object : ${fieldNamePath} %}
  {{ require_js('https://static.hsappstatic.net/media-bridge-embed-js/ex/v1.js') }}
  <div class="oembed_container {% if oEmbedData.size_type == 'auto_full_width' %} oembed_container--full-size{% endif %}" id="oembed_container-{{name}}">
    <div class="iframe_wrapper"
      data-embed-response-html="{{ oEmbedData.oembed_response.html|escape }}"
      data-embed-response-width="{{ oEmbedData.oembed_response.width }}"
      data-embed-response-height="{{ oEmbedData.oembed_response.height }}"
      data-embed-url="{{ oEmbedData.oembed_url }}"
      data-source-type="{{ ${fieldNamePath}.source_type }}"
      {% unless oEmbedData.size_type == "auto_full_width" || oEmbedData.size_type == "exact" %}
      data-max-height="{% if oEmbedData.size_type == "auto_custom_max" %}{{ oEmbedData.max_height }}{% endif %}"
      data-max-width="{% if oEmbedData.size_type == "auto_custom_max" %}{{ oEmbedData.max_width }}{% endif %}"
      {% endunless %}
      {% if oEmbedData.size_type == "exact" %}
      data-height="{{ oEmbedData.height }}"
      data-width="{{ oEmbedData.width }}"
      {% endif %}
      >
    </div>
  </div>` : `{% if ${fieldNamePath}.source_type == "oembed" %}
  {% set oembedResponse = ${fieldNamePath}.oembed_response  %}
  <div class="oembed_container {% if ${fieldNamePath}.size_type == 'auto_full_width' %} oembed_container--full-size{% endif %}" id="oembed_container-{{name}}">
    <div class="iframe_wrapper"
      data-embed-response-html="{{ oembedResponse.html|escape }}"
      data-embed-response-width="{{ oembedResponse.width }}"
      data-embed-response-height="{{ oembedResponse.height }}"
      data-embed-url="{{ ${fieldNamePath}.oembed_url }}"
      {% unless ${fieldNamePath}.size_type == "auto_full_width" || ${fieldNamePath}.size_type == "exact" %}
      data-max-height="{% if ${fieldNamePath}.size_type == "auto_custom_max" %}{{ ${fieldNamePath}.max_height }}{% endif %}"
      data-max-width="{% if ${fieldNamePath}.size_type == "auto_custom_max" %}{{ ${fieldNamePath}.max_width }}{% endif %}"
      {% endunless %}
      {% if ${fieldNamePath}.size_type == "exact" %}
      data-height="{{ ${fieldNamePath}.height }}"
      data-width="{{ ${fieldNamePath}.width }}"
      {% endif %}
      >
    </div>
  </div>`;
  return `${oEmbedCase}
  {% require_css %}
    <style>
      .oembed_container {
        display: inline-block;
        height: 100%;
        position: relative;
        width: 100%;
      }

      .oembed_container .iframe_wrapper > * {
        height: 100%;
        left: 0;
        margin: 0 auto;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
      }

      .iframe_wrapper {
        height: 0;
        padding-bottom: 56.25%;
        padding-top: 25px;
        position: relative;
      }
    </style>
  {% end_require_css %}
  {% require_js %}
    <script>
      function loadEmbedField(oembedContainer) {
        const iframeWrapper = oembedContainer.querySelector('.iframe_wrapper');
        if (!iframeWrapper) {
          return;
        }
        const url = iframeWrapper.dataset.embedUrl;
        if (!url) {
          return;
        }
        ${withMediaBridge ? mediaBridgeShortCircuit : ''}

        function setIframe(data) {
          let {
            maxHeight,
            maxWidth,
            height,
            width,
          } = iframeWrapper.dataset;
          maxHeight = maxHeight !== undefined && !maxHeight ? data.height : maxHeight;
          maxWidth = maxWidth !== undefined && !maxWidth ? data.width : maxWidth;
          height = height !== undefined && !height ? data.height : height;
          width = width !== undefined && !width ? data.width : width;

          const el = document.createElement('div');
          el.innerHTML = data.html;
          const iframe = el.firstChild;
          iframeWrapper.appendChild(iframe);

          if (maxHeight) {
            const maxHeightStr = maxHeight.toString(10) + "px";
            oembedContainer.style.maxHeight = maxHeightStr;
            iframe.style.maxHeight = maxHeightStr;
          }

          if (maxWidth) {
            const maxWidthStr = maxWidth.toString(10) + "px";
            oembedContainer.style.maxWidth = maxWidthStr;
            iframe.style.maxWidth = maxWidthStr;
          }

          if (height) {
            const heightStr = height.toString(10) + "px";
            oembedContainer.style.height = heightStr;
            iframe.style.height = heightStr;
          }

          if (width) {
            const widthStr = width.toString(10) + "px";
            oembedContainer.style.width = widthStr;
            iframe.style.width = widthStr;
          }
        }

        const embedResponse = {
          html: iframeWrapper.dataset.embedResponseHtml,
          width: iframeWrapper.dataset.embedResponseWidth,
          height: iframeWrapper.dataset.embedResponseHeight
        };

        if (embedResponse.html) {
          setIframe(embedResponse);
          return;
        }

        const request = new XMLHttpRequest();
        const requestUrl = "/_hcms/oembed?url=" + encodeURIComponent(url) + "&autoplay=0";
        request.open('GET', requestUrl, true);
        request.onload = function() {
          if (request.status >= 200 && request.status < 400) {
            const data = JSON.parse(request.responseText);
            setIframe(data);
          } else {
            console.error('Server reached, error retrieving results.');
          }
        };
        request.onerror = function() {
          console.error('Could not reach the server.');
        };
        request.send();
      }

      document.addEventListener('DOMContentLoaded', function() {
        var oEmbedContainers = document.getElementsByClassName('oembed_container');
        Array.prototype.forEach.call(oEmbedContainers, loadEmbedField)
      });
    </script>
  {% end_require_js %}
{% else %}
  <div id="embed_container" class="embed_container">
    <div class="iframe_wrapper">
      {{ ${fieldNamePath}.embed_html }}
    </div>
  </div>
  {% require_css %}
    <style>
      .iframe_wrapper {
        height: 0;
        padding-bottom: 56.25%;
        padding-top: 25px;
        position: relative;
      }

      .embed_container {
        display: inline-block;
        height: 100%;
        position: relative;
        width: 100%;
      }

      .embed_container iframe {
        left: 0;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        right: 0;
        top: 0;
      }
    </style>
  {% end_require_css %}
{% endif %}
`;
};
export const getPaymentFieldEmbedCode = fieldNamePath => {
  return `<!-- Start of Payments Embed Script -->
<div class="payments-iframe-container" data-src="{{ ${fieldNamePath}.properties.checkoutUrl }}?embed=true&hideOrderSummary=true"></div>
<script type="text/javascript" src="https://static.hsappstatic.net/payments-embed/ex/PaymentsEmbedCode.js"></script>
<!-- End of Payments Embed Script -->`;
};

function removeWhiteSpaceLines(str) {
  return str.split('\n').filter(line => line.trim()).join('\n');
}

export const getVideoFieldSnippet = fieldNamePath => {
  return removeWhiteSpaceLines(`
{% if ${fieldNamePath}.player_id %}
  {% set max_width = ${fieldNamePath}.size_type == 'auto_custom_max' ? ${fieldNamePath}.max_width : ${fieldNamePath}.width %}
  {% set max_height = ${fieldNamePath}.size_type == 'auto_custom_max' ? ${fieldNamePath}.max_height : ${fieldNamePath}.height %}
  {% video_player "embed_player"
    player_id={{ ${fieldNamePath}.player_id }}
    type={{ ${fieldNamePath}.player_type || 'scriptV4' }}
    full_width={{ ${fieldNamePath}.size_type == 'auto_full_width' }},
    conversion_asset={{ ${fieldNamePath}.conversion_asset|tojson|safe }}
    autoplay={{ ${fieldNamePath}.autoplay }}
    hidden_controls={{ ${fieldNamePath}.hide_controls }}
    loop={{ ${fieldNamePath}.loop_video }}
    muted={{ ${fieldNamePath}.mute_by_default }}
  %}
{% endif %}`);
};